export const GeneralInformationMessagePath = '/general-information-message';
export const loadGeneralInformationMessage = async axios => {
  const {
    data
  } = await axios.get(GeneralInformationMessagePath);
  return data.data ?? null;
};